
import { defineComponent, ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
export default defineComponent({
    props: {
        zoomRatio: {
            type: Number,
            required: true,
            default: 1
        },
        baseRatio: {
            type: Number,
            required: true,
            default: 1
        }
    },
    setup(props) {
        const store = useStore()
        const varousel=ref()
        const systemList = ref(['bx-background', 'ml-background', 'dy-background', 'jz-background'])
        const topVal = computed(() => {
            if (props.baseRatio * props.zoomRatio >= 0.9) {
                return `${-50 * props.baseRatio * props.zoomRatio}px`
            }
            if (props.baseRatio * props.zoomRatio < 0.9 && props.baseRatio * props.zoomRatio >= 0.8) {
                return `${-10 * props.baseRatio * props.zoomRatio}px`
            }
            return `${50 * props.baseRatio * props.zoomRatio}px`
        })

        const getShowTask = computed(()=>{
            //返回的是ref对象
            return store.state.count
        })
        
        watch(getShowTask, (newVal: any, oldVal: any) => {
            varousel.value?.goTo(newVal)
        }, {immediate:true,deep:true})

        return {
            systemList,
            topVal,
            varousel,
        }
    }
})
